import { useState, useEffect } from "react";
import api from "@/lib/api";

const MIN_CODE_LENGTH = 7;

/**
 * Valide un code coach via GET /api/auth/coach-code/{code}
 * @returns {{ preview: { valid: boolean, name?: string, pseudo?: string } | null, checking: boolean }}
 */
export function useCoachCodeLookup(code) {
  const [preview, setPreview] = useState(null);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const normalized = (code || "").trim().toUpperCase();
    if (!normalized || normalized.length < MIN_CODE_LENGTH) {
      setPreview(null);
      setChecking(false);
      return undefined;
    }

    setChecking(true);
    const timer = setTimeout(async () => {
      try {
        const { data } = await api.get(`/auth/coach-code/${encodeURIComponent(normalized)}`);
        setPreview(
          data?.valid
            ? { valid: true, name: data.coach_name, pseudo: data.pseudo }
            : { valid: false }
        );
      } catch {
        setPreview({ valid: false });
      } finally {
        setChecking(false);
      }
    }, 450);

    return () => clearTimeout(timer);
  }, [code]);

  return { preview, checking };
}

export function normalizeCoachCode(value) {
  return (value || "").toUpperCase().replace(/\s/g, "");
}